import { gql } from '@apollo/client'

import { SIMPLE_USER_FRAGMENT } from '../../../common/graphql/fragments'

import BRAND_LIST_FRAGMENT from './brand-list-fragment'

const BrandCurationTaskListFragment = gql`
  fragment BrandCurationTaskListFragment on BrandCurationTask {
    id
    taskStatus
    awaitingStatus
    updatedAt
    reopenedAt
    createdAt
    isReopenedManually
    brand {
      ...BrandListFragment
    }

    assignedCurator {
      ...SimpleUserFragment
    }

    assignedQa {
      ...SimpleUserFragment
    }

    assignedQc {
      ...SimpleUserFragment
    }
  }
  ${SIMPLE_USER_FRAGMENT}
  ${BRAND_LIST_FRAGMENT}
`

export default BrandCurationTaskListFragment
